export const DEFAULT_ITEMS_COUNT_PER_REQUEST = 50;
